import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button, Card, Form, Icon, Row } from 'antd'
import { Formik } from 'formik'
import moment from 'moment'

import CalendarIcon from '../../../assets/images/calendarIcon.svg'
import InfoIcon from '../../../assets/images/infoIcon.svg'
import MapIcon from '../../../assets/images/mapIcon.svg'
import CustomInput from '../../../components/CustomInput/customInput'
import CustomSelect from '../../../components/CustomSelect/customSelect'
import FormHeader from '../../../components/FormHeader/FormHeader'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { isAdmin, isGR, isRtv } from '../../../util/profiles'
import { CULTIVARS_SCHEMA } from './CultivarsSchema'

const CreateCultivars = ({
  onCreateCultivar,
  formattedMaterials = [],
  formattedDemandTypes = [],
  formattedCultivarsTypes = [],
  cultivars = {},
  customerId,
  selectedDistrictId
}) => {
  const [customerName, setCustomerName] = useState('')
  const [regionDistrict, setRegionDistrict] = useState('')
  const currentUser = useSelector((state) => state.auth.auth)
  const { regions, districts } = currentUser
  const selectedDistrict = (districts || []).find((district) => district.id === selectedDistrictId)
  const selectedRegion = (regions || []).find((region) => region.id === selectedDistrict?.regionId)

  useEffect(() => {
    retrieveCustomerLocations(customerId)
  }, [cultivars, customerId])

  function onSubmit(values, { resetForm }) {
    onCreateCultivar({ ...values })
    resetForm()
  }

  async function retrieveCustomerLocations(id) {
    try {
      let params = {}
      if (isRtv() || isAdmin()) {
        params.districtId = selectedDistrictId
      } else if (isGR()) {
        params.regionId = selectedRegion?.id
      }
      const items = await request(api.listCustomerLocations(id, { params }))

      const { districtName, regionName } = items[0]
      const customer = await api.getCustomer(customerId)
      setCustomerName(customer.name)
      setRegionDistrict(`${regionName}/${districtName}`)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      validationSchema={CULTIVARS_SCHEMA}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, setFieldValue, submitForm }) => (
        <Form layout="vertical">
          <FormHeader color="#000" title={getMessage('customer.tab.cultivars')} orientation="left" type="horizontal" />

          <div className="main-cards" style={{ padding: '0px 20px 20px 20px' }}>
            <Card className="ant-card-bordered card">
              <div className="container-card">
                <img src={InfoIcon} alt="InfoIcon" width={25} style={{ marginRight: 10 }} />
                <div className="label-card-info">
                  <span>Nome do eleito</span>
                  <span style={{ fontWeight: 'bold' }}>{customerName}</span>
                </div>
              </div>
            </Card>

            <Card className="ant-card-bordered card">
              <div className="container-card">
                <img src={MapIcon} alt="MapIcon" width={25} style={{ marginRight: 10 }} />
                <div className="label-card-info">
                  <span>Regional / Distrito</span>
                  <span style={{ fontWeight: 'bold' }}>{regionDistrict}</span>
                </div>
              </div>
            </Card>

            <Card className="ant-card-bordered card">
              <div className="container-card">
                <img src={CalendarIcon} alt="CalendarIcon" width={25} style={{ marginRight: 10 }} />
                <div className="label-card-info">
                  <span>Mês / Ano vigente</span>
                  <span style={{ fontWeight: 'bold' }}>{moment().format('MM/YYYY')}</span>
                </div>
              </div>
            </Card>
          </div>

          <Row type="flex" justify="space-around">
            <CustomSelect
              showSearch
              field="materialsId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={8}
              value={values}
              values={formattedMaterials}
            />
            <CustomSelect
              showSearch
              field="cultivarsDemandTypeId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={formattedDemandTypes}
            />
            <CustomInput
              field="area"
              type="number"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              handleBlur={() => {}}
            />
            <CustomSelect
              showSearch
              field="cultivarsTypeId"
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={formattedCultivarsTypes}
            />
            <Button type="primary" className="button-action-plus" onClick={submitForm}>
              <Icon type="plus" />
            </Button>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default CreateCultivars
